import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import ResetPasswordFormComponent from '../../components/resetPasswordForm/resetPasswordForm';

export default function ResetPasswordPage() {
    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Reset Password | Prepal</title>
                <meta name="description" content="Create a new password for your Prepal account. Secure your account with a strong password." />
                <meta name="keywords" content="Prepal, reset password, new password, account security" />
                <meta name="author" content="Prepal Team" />
            </Helmet>
            <ResetPasswordFormComponent />
        </>
    );
}